var map = {
	"./2_pc_suit.png": 1734,
	"./3_pc_suit.png": 7875,
	"./Druvet_double.jpg": 6322,
	"./Druvet_single.jpg": 3726,
	"./Leatherbag_small.webp": 7831,
	"./Quilt_double.jpg": 2472,
	"./Quilt_single.jpg": 4656,
	"./bed_cover_double.jpg": 6753,
	"./bed_cover_single.jpg": 8782,
	"./bed_sheet_double.jpg": 1683,
	"./bed_sheet_single.jpg": 4367,
	"./belt.jpg": 8022,
	"./blanket(single).jpg": 793,
	"./blazer.png": 120,
	"./blouse.png": 9119,
	"./boots.png": 5654,
	"./cardigin.jpg": 2145,
	"./double_blanket.jpg": 1133,
	"./dress.png": 759,
	"./dummy_adhaarcard.png": 3282,
	"./dummy_driving_licence.jpg": 9268,
	"./dummy_profile_image.jpg": 3893,
	"./dupatta.jpg": 5740,
	"./gown.jpg": 4622,
	"./handbag_large.jpg": 9729,
	"./handbag_medium.jpg": 6736,
	"./handbag_small.jpeg": 9415,
	"./heavy_blouse.webp": 5405,
	"./heavy_dress.jpg": 1952,
	"./heavy_duptta.jpg": 8040,
	"./heavy_gown.jpg": 4838,
	"./heavy_lehenga.jpg": 5573,
	"./heavysaree.png": 6626,
	"./hoodie.png": 3984,
	"./jeans.png": 3927,
	"./kurta_pajama.jpg": 7451,
	"./large_pillow.jpg": 8162,
	"./leather_bag_large.jpg": 852,
	"./leather_belt.webp": 5385,
	"./leather_jacket.jpg": 2543,
	"./leather_shoes.jpg": 9298,
	"./lehenga.png": 5901,
	"./longblazer.png": 6218,
	"./mediumlehenga.png": 7937,
	"./mediumsaree.png": 940,
	"./pillow_cover.jpg": 3184,
	"./sandals.png": 7265,
	"./saree.png": 3790,
	"./shirt.png": 6266,
	"./shwal.jpg": 6548,
	"./sliders.png": 5337,
	"./small_pillow.jpg": 4273,
	"./sports_bag.jpg": 7903,
	"./sportsshoes.png": 5119,
	"./srug.jpg": 3070,
	"./stilettos.png": 5129,
	"./suedeshoes.png": 7623,
	"./trouser.png": 8398,
	"./w_f_non-wearable.jpg": 8902,
	"./w_f_wearable.jpg": 5441,
	"./w_i_non-wearable.jpg": 9069,
	"./w_i_wearable.jpg": 7060,
	"./winter_jacket.jpg": 6356,
	"./winterjacket.png": 6185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 309;